import mikaPic from "@/public/images/artists/mika.jpeg";
import { Artist } from "@/types/types";

export const mika = {
  id: "141",
  name: "Mika",
  image: mikaPic,
  description: `Mika's voice possesses a hoarse and mellow quality that adds a distinctive texture to its resonant and robust timbre. The hoarseness lends a raw edge, while the mellow undertones infuse warmth and depth. This combination results in a voice that is rich, deep, and full of character.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fmika-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: [
        "Pop",
        "Dance",
        "Unprocessed",
        "Indie",
        "Rock",
        "Soul",
        "Folk",
        "Country",
        "Blues",
        "Deep",
        "Airy",
      ],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Bass",
        high: "High",
      },
      specific: {
        low: 38,
        high: 72,
      },
      sweetSpot: 57,
    },
  },
} as const satisfies Artist;
